<template>
  <b-modal :id="idModalFileUploaded" class="modal-info modal-prepare__detail" size="xl" scrollable centered @hidden="handleCloseModal">
      <template v-slot:modal-header>
        <div class="modal-info__head modal-info__head--psmall display-flex-center justify-content-between full-width">
          <div class="modal-info__title full-width">
            <h4 class="font-sanpro-bold primary-color-txt">Học liệu của tôi</h4>
            <div class="modal-add-slide__head__action display-flex-center justify-content-between">
              <div class="modal-add-slide__head__action__form display-flex-center">
                <a href="javascript:;" class="btn btn-main font-size-16 border-rd-20 form-file-hide display-flex-center justify-content-center modal-add-slide__upload">
                  <i class="icon-upload color-light"></i>
                  Tải lên
                  <input v-if="fileType === typeImg" type="file" id="file_image" ref="file_image" @change="uploadImage()">
                  <input v-else-if="fileType === typeAudio" type="file" id="file_audio" ref="file_audio" @change="uploadAudio()">
                  <input v-else-if="fileType === typeVideo" type="file" id="file_video" ref="file_video" @change="uploadVideo()">
                </a>
                <div class="input-custom-icon modal-add-slide__keyword">
                  <input 
                    v-model.lazy="keyword"
                    v-debounce="300"
                    type="text"
                    placeholder="Tìm kiếm"
                    class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width"
                  >
                  <i class="icon-search font-size-16 primary-color"></i>
                </div>
              </div>
              <p class="modal-add-slide__desc-choose margin-0 primary-color-txt font-sanpro-semibold font-size-18">
                Đã chọn {{ dataChoosed.length }} học liệu
              </p>
            </div>
          </div>
          <span @click="$bvModal.hide(idModalFileUploaded)" class="modal-info__close"><i class="icon-close"></i></span>
        </div>
      </template>
      <div class="modal-info__body primary-color-txt font-sanpro-light bg-color-light">
        <div class="modal-add-slide__list display-flex-wrap">
          <div
            v-for="(item, index) of datas"
            :key="index"
            class="item item--uploaded position-rel"
            @click="handleChoosedData(item)"
          >
            <!-- :class="{'active': dataChoosed.includes(item.lessonPlanFileId)}" -->
            <div class="item__head aspect-ratio aspect-ratio--16-9">
              <div class="item__img">
                <img v-if="checkImage(item.fileRef)" :src="`${appUrl}/${item.fileRef}`" :alt="item.name">
              </div>
              <div v-if="dataChoosed.includes(item.lessonPlanFileId)" class="item__checked">
                <img :src="doneIcon" alt="Chọn học liệu">
              </div>
              <div class="item__icon">
                <img v-if="item.fileRef && checkImage(item.fileRef)" :src="imgIcon" alt="Học liệu">
                <img v-else-if="item.fileRef && checkVideo(item.fileRef)" :src="videoIcon" alt="Học liệu">
                <img v-else-if="item.fileRef && checkAudio(item.fileRef)" :src="audioIcon" alt="Học liệu">
              </div>
            </div>
            <h4 class="item__title font-size-16 primary-color-txt font-sanpro-light">
              {{ item.name }}
            </h4>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="modal-add-slide__footer display-flex-center justify-content-end">
          <a href="javascript:;" class="font-size-16 primary-color font-weight-semi-bold" @click="$bvModal.hide(idModalFileUploaded)">Hủy</a>
          <button type="button" class="btn btn-main font-size-16 border-rd-20 display-flex-center justify-content-center" @click="handleInsertItems2Slide">
            Hoàn thành
          </button>
        </div>
      </template>
    </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { STORE_KEY, FILE_TYPE_UPLOADED_IMG, FILE_TYPE_UPLOADED_VIDEO, FILE_TYPE_UPLOADED_AUDIO, MEDIA_TYPE_IMG, MEDIA_TYPE_VIDEO, MEDIA_TYPE_AUDIO } from './../../_store/constants'
import fileService from './../../_api/fileService'
import debounce from "@/directives/debounce"
import mixinsDetailLesson from './../../_store/mixinsDetailLesson'
import { APP_CONFIG } from '@/utils/constants'
import mixinsFiles from '@/components/content-files/mixinsFiles'

const imgIcon = require('@/assets/images/linktypes/image.svg')
const videoIcon = require('@/assets/images/linktypes/play.svg')
const audioIcon = require('@/assets/images/linktypes/audio.svg')
const doneIcon = require('@/assets/images/linktypes/done.svg')

export default {
  name: 'ModalFileUploaded',
  mixins: [ mixinsDetailLesson, mixinsFiles ],
  directives: { debounce },
  props: {
    fileType: Number
  },
  data () {
    return {
      keyword: '',
      paramSearch: {fileType: this.fileType, keyword: ''},
      datas: [],
      appUrl: APP_CONFIG.appUrl,
      typeImg: MEDIA_TYPE_IMG,
      typeVideo: MEDIA_TYPE_VIDEO,
      typeAudio: MEDIA_TYPE_AUDIO,
      file: {},
      dataChoosed: [],
      dataValueChoosed: [],
      fileChunk: [],
      fileVideo: {},
      imgIcon,
      videoIcon,
      audioIcon,
      doneIcon
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['idModalFileUploaded'])
  },
  watch: {
    fileType (newVal) {
      this.paramSearch.fileType = newVal
    },
    keyword: 'searchFilesByKeyword',
    fileChunk(n) {
      if (n.length > 0) {
        let partCount = this.totalFileChunk - n.length + 1;
        let filePartName = this.fileVideo.name + ".part_" + partCount + "." + this.totalFileChunk;  
        this.uploadChunk(this.fileChunk[0], filePartName);
      }
    },
  },
  mounted () {
    this.getDatas()
  },
  methods: {
    ...mapActions('common', ['setLoading']),
    ...mapActions(STORE_KEY, ['acSetVisibleModalFileLoaded']),

    getDatas () {
      let self = this
      fileService.filter(self.paramSearch).then(res => {
        self.datas = res ? res : []
      })
    },

    searchFilesByKeyword (val) {
      this.paramSearch.keyword = val
      this.getDatas()
    },

    handleCloseModal () {
      this.acSetVisibleModalFileLoaded(false)
    },

    handleChoosedData (val) {
      if (this.dataChoosed.length === 0 || !this.dataChoosed.includes(val.lessonPlanFileId)) {
        this.dataChoosed.push(val.lessonPlanFileId)
        this.dataValueChoosed.push(val)
      } else {
        this.dataChoosed = this.dataChoosed.filter(choose => choose !== val.lessonPlanFileId)
        this.dataValueChoosed =  this.dataValueChoosed.filter(link => link.lessonPlanFileId !== val.lessonPlanFileId)
      }
    },

    async handleInsertItems2Slide () {
      let self = this
      if (!self.dataValueChoosed || self.dataValueChoosed.length === 0) {
        self.$toast.warning('Bạn hãy chọn file cần chèn vào slide!')
        return;
      } else {
        const requestAddFiles = await self.dataValueChoosed.map(item => {
          return self.addFile2Slide(item)
        });

        Promise.all(requestAddFiles).then(res => {
          self.$bvModal.hide(self.idModalFileUploaded)
        })
      }
    },

    addFile2Slide (data) {
      let self = this
      switch (self.fileType) {
        case self.typeVideo:
          self.addVideo(data)
          break;
        case self.typeAudio:
          self.addAudio(data)
          break;
        default:
          self.addImageUrl(`${self.appUrl}/${data.fileRef}`)
          break;
      }
    },

    uploadImage() {
      let self = this;
      self.setLoading(true);
      this.file = this.$refs.file_image.files[0];
      var isValid = false;
      if (this.file.type !== '' && this.file.type.split('/').length == 2 && this.file.type.split('/')[0] === 'image') {
        isValid = true;
      }
      if (!isValid) {
        self.$toast.error('Vui lòng chọn file đúng định dạng');
      } else {
          var fileData = { name: this.file.name, fileExt: this.file.type.split('/')[1], fileSize: this.file.size, fileType: MEDIA_TYPE_IMG };
          let formData = new FormData();
          formData.append('file', this.file);
          fileService.uploadNews(formData).then((response) => {
            if (response.data.status == 'success') {
              fileData.fileRef = response.data.data;
              self.handleSaveFile(fileData);
            }
          }).finally();
      }
    },

    uploadAudio() {
        let self = this;
        self.setLoading(true);
        this.file = this.$refs.file_audio.files[0];
        let isValid = false;
        if (this.file.type !== '' && this.file.type.split('/').length === 2 && this.file.type.split('/')[0] === 'audio') {
          isValid = true;
        }
        if (!isValid) {
          self.$toast.error('Vui lòng chọn file đúng định dạng')
          self.setLoading(false)
        } else {
          let fileData = { name: this.file.name, fileExt: this.file.type.split('/')[1], fileSize: this.file.size, fileType: MEDIA_TYPE_AUDIO };
          let formData = new FormData();
          formData.append('file', this.file);
          fileService.upload(formData).then((response) => {
            if (response.data.status == 'success') {
              fileData.fileRef = response.data.data
              self.handleSaveFile(fileData);
            }
          }).finally(() => self.setLoading(false))
      }
    },

    uploadVideo() {
      let self = this;
      self.setLoading(true);
      this.fileVideo = this.$refs.file_video.files[0]
      let isValid = false
      if (self.fileVideo.type !== '' && self.fileVideo.type.split('/').length === 2 && self.fileVideo.type.split('/')[0] === 'video') {
        isValid = true
      }
      if (!isValid) {
        self.$toast.error('Vui lòng chọn file đúng định dạng')
      } else {
        let maxFileSizeMB = 10
        let bufferChunkSize = maxFileSizeMB * (1024 * 1024);
        let fileStreamPos = 0;
        let endPos = bufferChunkSize;
        let size = self.fileVideo.size;
        while (fileStreamPos < size) {
            self.fileChunk.push(self.fileVideo.slice(fileStreamPos, endPos));
            fileStreamPos = endPos;
            endPos = fileStreamPos + bufferChunkSize;
        }
        self.totalFileChunk = self.fileChunk.length;
      }
    },

    uploadChunk(chunk, fileName) {
      let self = this
      let formData = new FormData();  
      formData.append('file', chunk, fileName);  
      fileService.upload(formData).then((response) => {
        if (response.data.status == 'success') {
          this.fileChunk.shift();
          if (this.fileChunk.length == 0 && response.data.data !== null) {
            let fileData = { name: this.fileVideo.name, fileExt: this.fileVideo.type.split('/')[1], fileSize: this.fileVideo.size, fileType: MEDIA_TYPE_VIDEO };
            fileData.fileRef = response.data.data;
            self.handleSaveFile(fileData);
          }
        }
      }).finally();
    },

    async handleSaveFile (fileData) {
      /*
      * @params
      * fileData: file data upload
      * calback getData: boolean
      */
      await this.saveMediaFile(fileData, false);
      this.getDatas()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
